import React from "react";
import { Box, Button, Text } from "grommet";
import { Play, Pause, Stop } from "grommet-icons";

export const QuizHeader = ({
  currentQuestionIndex,
  numberOfQuestions,
  isPaused,
  timeLeft,
  handlePause,
  handleStop,
  formatTime,
}) => {
  return (
    <Box direction="row" justify="between" margin="small" pad="small">
      <Box>
        <Text size="large">
          Question {currentQuestionIndex + 1} of {numberOfQuestions}
        </Text>
      </Box>
      <Box direction="row" justify="center">
        {/* <Button
          icon={isPaused ? <Play color="brand" /> : <Pause color="brand" />}
          label={isPaused ? "Resume assessment" : "Pause assessment"}
          onClick={handlePause}
        /> */}
        <Button
          icon={<Stop color="red" />}
          label="Stop assessment"
          onClick={handleStop}
        />
      </Box>
      <Box>
        <Text size="large">Time Left: {formatTime(timeLeft)}</Text>
      </Box>
    </Box>
  );
};
